import ApiService from './ApiService';

export default class UserApi extends ApiService {
    constructor() {
        super('users');
    }

    getUsers(payload) {
        return this.get('', payload);
    }

    getUsersCombobox(payload) {
        return this.get('combobox', payload);
    }

    updateStatus(data) {
        const { code, payload } = data;
        return this.put(`status/${code}`, payload);
    }

    deleteUser(code) {
        return this.delete(code);
    }

    createUser(payload) {
        return this.post('', payload);
    }

    getUser(code) {
        return this.get(code);
    }

    editUser(data) {
        const { code, payload } = data;
        return this.put(`${code}`, payload);
    }
}
